export default {
  phone: '+7 495 668 09 89',
  offerLink: 'https://s.algoritmika.org/zqx8un',
  mailing: 'https://algoritmika.org/mailing',
  privacy: 'https://algoritmika.org/privacy',
  currency: '$',
}
